import { FC } from "react"
import { useParams } from "react-router-dom"
import { UserbotPage } from "./userbotPage"
import { BatchProgress } from "../components/batches/batchProgress"

export const BatchProgressPage: FC = () => {
  const { id } = useParams<{ id: string }>()
  return (
    <UserbotPage title="Запуск по аккаунтам">
      {id ? <BatchProgress jobId={id} /> : null}
    </UserbotPage>
  )
}
